import { Required } from "./Required";
export { ErrorText } from "./ErrorText";
export var ErrorTypes = {
    Required: Required
};
